import { useEffect, useRef, useState } from "react";
import { apiRequest } from "../lib/api";

type IdentityApi = { initialize: (options: { client_id: string; nonce: string; use_fedcm_for_button: boolean; callback: (response: { credential: string }) => void }) => void; renderButton: (element: HTMLElement, options: Record<string, unknown>) => void };
let identityScript: Promise<void> | undefined;
function loadIdentity() {
  if (!identityScript) identityScript = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => { identityScript = undefined; script.remove(); reject(new Error("Google sign-in could not load. Check your connection and try again.")); };
    document.head.appendChild(script);
  });
  return identityScript;
}

export function GoogleSignIn({ clientId, onCredential, busy }: { clientId: string; onCredential: (credential: string, nonce: string) => Promise<void>; busy: boolean }) {
  const host = useRef<HTMLDivElement>(null);
  const callback = useRef(onCredential);
  callback.current = onCredential;
  const disabled = useRef(busy);
  disabled.current = busy;
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let disposed = false;
    setError("");
    void Promise.all([loadIdentity(), apiRequest<{ nonce: string }>("/api/customers/auth/google/challenge", { method: "POST", body: "{}" })]).then(([, challenge]) => {
      if (disposed || !host.current) return;
      const api = (window as unknown as { google: { accounts: { id: IdentityApi } } }).google.accounts.id;
      api.initialize({ client_id: clientId, nonce: challenge.nonce, use_fedcm_for_button: true, callback: response => { if (!disposed && !disabled.current) void callback.current(response.credential, challenge.nonce).catch(failure => { if (!disposed) setError(failure instanceof Error ? failure.message : "Google sign-in failed."); }); } });
      host.current.replaceChildren();
      api.renderButton(host.current, { theme: "outline", size: "large", text: "signin_with", width: 300 });
    }).catch(failure => { if (!disposed) setError(failure instanceof Error ? failure.message : "Google sign-in failed."); });
    return () => { disposed = true; };
  }, [clientId, attempt]);
  return <div className="google-signin"><div ref={host} style={busy ? { pointerEvents: "none", opacity: 0.6 } : undefined} aria-busy={busy} />{error ? <div className="status-banner error" role="alert">{error}<button type="button" disabled={busy} onClick={() => setAttempt(value => value + 1)}>Try Google again</button></div> : null}</div>;
}
